<template>
    <form class="side-search" @submit.prevent="open">
        <input
            ref="inputEl"
            v-model="q"
            class="search-input"
            type="text"
            :placeholder="placeholder"
            @focus="open"
            @click="open"
            autocomplete="off"
        />
    </form>
</template>

<script setup lang="ts">
import { nextTick, onMounted, ref } from 'vue';

const props = defineProps<{ placeholder?: string }>();
const emit = defineEmits<{ (e: 'open-sheet', payload: { q: string }): void }>();

const q = ref('');
const inputEl = ref<HTMLInputElement | null>(null);

function open() {
    // Pass whatever is typed so far (or empty)
    emit('open-sheet', { q: (q.value || '').trim() });
    // Immediately blur so typing continues in SearchSheet
    nextTick(() => inputEl.value?.blur());
}

// Optional hotkey: "/" opens the sheet
onMounted(() => {
    window.addEventListener('keydown', (e) => {
        const t = e.target as HTMLElement | null;
        if (t && (t.tagName === 'INPUT' || t.isContentEditable)) return;
        if (e.key === '/') {
            e.preventDefault();
            open();
        }
    });
});
</script>

<style scoped lang="scss">
.side-search {
    position: relative;
}
.search-input {
    width: 100%;
    padding: 10px 12px;
    border: 1px solid #444;
    border-radius: 12px;
    outline: none;
    background: #111;
    color: #eee;
}
</style>
